export interface ICommunicationPreferences {
  showGuardianConsent: boolean;
  marketingOptIn?: boolean;
  agreeToTsAndCs?: boolean;
  guardianConsent?: boolean;
}
